import { FESTIVAL_TYPE } from "../../types";

export const festivalImage = {
  [FESTIVAL_TYPE.WONDER]: {
    leftImage:
      "https://faradars.org/wp-content/uploads/2024/05/01/festival-wonder.svg",
    patternBackground:
      "https://faradars.org/wp-content/uploads/2024/04/30/stars.svg",
    background: {
      40: "",
      50: "",
      60: "",
      65: "",
      70: "",
      75: "",
      80: "",
    },
    bannerImage: {
      xxl: "",
      xl: "",
      l: "",
      m: "",
      s: "",
      xs: "",
      xxs: "",
    },
  },
  [FESTIVAL_TYPE.PERCENT]: {
    leftImage:
      "https://faradars.org/wp-content/uploads/2024/04/30/percentage-left.svg",
    patternBackground:
      "https://faradars.org/wp-content/uploads/2024/04/30/stars.svg",
    background: {
      40: "https://faradars.org/wp-content/uploads/2024/11/03/40.svg",
      50: "https://faradars.org/wp-content/uploads/2024/11/03/50.svg",
      60: "https://faradars.org/wp-content/uploads/2024/11/03/60.svg",
      65: "https://faradars.org/wp-content/uploads/2024/11/03/65.svg",
      70: "https://faradars.org/wp-content/uploads/2024/11/03/70.svg",
      75: "https://faradars.org/wp-content/uploads/2025/03/17/75darsad.svg",
      80: "https://faradars.org/wp-content/uploads/2025/12/07/80.svg",
    },
    bannerImage: {
      xxl: "",
      xl: "",
      l: "",
      m: "",
      s: "",
      xs: "",
      xxs: "",
    },
  },
  [FESTIVAL_TYPE.STEPPED_AMOUNT]: {
    leftImage:
      "https://faradars.org/wp-content/uploads/2023/12/25/stepped-amount-left.png",
    patternBackground:
      "https://faradars.org/wp-content/uploads/2024/04/30/stars.svg",
    background: {
      40: "",
      50: "",
      60: "",
      65: "",
      70: "",
      75: "",
      80: "",
    },
    bannerImage: {
      xxl: "",
      xl: "",
      l: "",
      m: "",
      s: "",
      xs: "",
      xxs: "",
    },
  },
  [FESTIVAL_TYPE.STEPPED_COUNT]: {
    leftImage:
      "https://faradars.org/wp-content/uploads/2023/12/25/stepped-count-left.png",
    patternBackground:
      "https://faradars.org/wp-content/uploads/2024/04/30/stars.svg",
    background: {
      40: "",
      50: "",
      60: "",
      65: "",
      70: "",
      75: "",
      80: "",
    },
    bannerImage: {
      xxl: "",
      xl: "",
      l: "",
      m: "",
      s: "",
      xs: "",
      xxs: "",
    },
  },
};
